import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dc47e7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-index" }
const _hoisted_2 = { class: "brand-index-center" }
const _hoisted_3 = { class: "brand-index-rank-lt" }
const _hoisted_4 = { class: "brand-index-rank-lt-title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 近3个月精装项目商家报名排行榜 ")
const _hoisted_6 = { class: "brand-index-rank-rt" }
const _hoisted_7 = { class: "brand-index-rank-rt-imgs" }
const _hoisted_8 = { class: "brand-index-rank-rt-imgs-item-img" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-index-rank-rt-imgs-item-img-status status4" }, null, -1))
const _hoisted_10 = { class: "brand-index-rank-rt-imgs-item-img-label" }
const _hoisted_11 = { class: "brand-index-rank-lt" }
const _hoisted_12 = { class: "brand-index-rank-lt-title" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 近3个月毛坯/存量房项目商家报名排行榜 ")
const _hoisted_14 = { class: "brand-index-rank-rt" }
const _hoisted_15 = { class: "brand-index-rank-rt-imgs" }
const _hoisted_16 = { class: "brand-index-rank-rt-imgs-item-img" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-index-rank-rt-imgs-item-img-status status4" }, null, -1))
const _hoisted_18 = { class: "brand-index-rank-rt-imgs-item-img-label" }
const _hoisted_19 = { class: "brand-index-aside" }
const _hoisted_20 = { class: "brand-index-aside-tp-hd" }
const _hoisted_21 = { class: "brand-index-aside-tp-hd-rt-name" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, "更多", -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "brand-index-main" }
const _hoisted_25 = { class: "brand-index-main-banners" }
const _hoisted_26 = { class: "brand-index-main-imgs" }
const _hoisted_27 = {
  class: "brand-library",
  style: {"display":"none"}
}
const _hoisted_28 = { class: "brand-library-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-library-title" }, "品牌库条件", -1))
const _hoisted_30 = { class: "brand-library-list" }
const _hoisted_31 = { class: "brand-library-item" }
const _hoisted_32 = { class: "brand-library-item-icon" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-library-item-name" }, "公平\\开放\\透明", -1))
const _hoisted_34 = { class: "brand-library-item" }
const _hoisted_35 = { class: "brand-library-item-icon" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-library-item-name" }, "质保金政策", -1))
const _hoisted_37 = { class: "brand-library-item" }
const _hoisted_38 = { class: "brand-library-item-icon" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-library-item-name" }, "黑名单机制", -1))
const _hoisted_40 = { class: "brand-library-item" }
const _hoisted_41 = { class: "brand-library-item-icon" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-library-item-name" }, "知名品牌", -1))
const _hoisted_43 = { class: "brand-library-item" }
const _hoisted_44 = { class: "brand-library-item-icon" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-library-item-name" }, "品质保证", -1))

import { ref, reactive } from 'vue';
import router from '@/router/index';
import Bottom from '../components/bottom.vue';
import store from '@/store/index';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeName = ref('全屋定制/整装');

const bindData = reactive({
  brandExampleList: [
    require('@/assets/fd/brand/example/ardu.jpg'),
    require('@/assets/fd/brand/example/goodnight.jpg'),
    require('@/assets/fd/brand/example/holike.jpg'),
    require('@/assets/fd/brand/example/kefan.jpg'),
    require('@/assets/fd/brand/example/kuka.jpg'),
    require('@/assets/fd/brand/example/mz.jpg'),
    require('@/assets/fd/brand/example/oppein.jpg'),
    require('@/assets/fd/brand/example/paterson.jpg'),
    require('@/assets/fd/brand/example/qm.jpg'),
    require('@/assets/fd/brand/example/redapple.jpg'),
    require('@/assets/fd/brand/example/richthome.jpg'),
    require('@/assets/fd/brand/example/rucci.jpg'),
    require('@/assets/fd/brand/example/snimay.jpg'),
    require('@/assets/fd/brand/example/sogal.jpg'),
    require('@/assets/fd/brand/example/taizi.jpg'),
  ],
  brandExampleBigList: [
    require('@/assets/fd/brand/example/quanu.jpg'),
    require('@/assets/fd/brand/example/royal.jpg'),
  ],
  tabData: [
    {
      id: 1,
      order:1,
      categoryId: '6b250ca949254c2db866afe151427b28',
      name: '全屋定制/整装',
      bg_color: '#ff9900',
      color: '#ff6600',
      tagList: new Array<string>(),
      hot_list: [
        '广东全屋定制',
        '广西整装',
        '佛山整装',
        '广西整装',
        '佛山整装',
        '西安整装',
        '广东全屋定制',
        '广西整装',
      ],
      icon: require('@/assets/fd/brand/icon1.png'),
      brandBannersList: new Array<any>(),
      refinedDecorationBrandList: new Array<any>(),
      roughcastBrandList: new Array<any>(),
      brandList: new Array<any>(),
      // tags: [
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居'
      // ]
    },
    {
      id: 2,
      order:2,
      categoryId: '2453275790f441cf9a9a3755345c8af6',
      name: '软装/家配',
      bg_color: '#b7b75c',
      color: '#b78900',
      tagList: new Array<string>(),
      hot_list: [
        '广东全屋定制',
        '广西整装',
        '佛山整装',
        '广西整装',
        '佛山整装',
        '西安整装',
        '广东全屋定制',
        '广西整装',
      ],
      icon: require('@/assets/fd/brand/icon2.png'),
      brandBannersList: new Array<any>(),
      refinedDecorationBrandList: new Array<any>(),
      roughcastBrandList: new Array<any>(),
      brandList: new Array<any>(),
      // tags: [
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居'
      // ]
    },
    {
      id: 3,
      order:3,
      categoryId: '42d9b6548de94dad9e3b596d06797f38',
      name: '建材/家装',
      bg_color: '#5cb789',
      color: '#6ab56a',
      tagList: new Array<string>(),
      hot_list: [
        '广东全屋定制',
        '广西整装',
        '佛山整装',
        '广西整装',
        '佛山整装',
        '西安整装',
        '广东全屋定制',
        '广西整装',
      ],
      icon: require('@/assets/fd/brand/icon3.png'),
      brandBannersList: new Array<any>(),
      refinedDecorationBrandList: new Array<any>(),
      roughcastBrandList: new Array<any>(),
      brandList: new Array<any>(),
      // tags: [
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居'
      // ]
    },
    {
      id: 4,
      order:4,
      categoryId: '44f94526a1db4bb8841e7afd4158a58b',
      name: '居家/用品',
      bg_color: '#8989e5',
      color: '#892ee5',
      tagList: new Array<string>(),
      hot_list: [
        '广东全屋定制',
        '广西整装',
        '佛山整装',
        '广西整装',
        '佛山整装',
        '西安整装',
        '广东全屋定制',
        '广西整装',
      ],
      icon: require('@/assets/fd/brand/icon4.png'),
      brandBannersList: new Array<any>(),
      refinedDecorationBrandList: new Array<any>(),
      roughcastBrandList: new Array<any>(),
      brandList: new Array<any>(),
      // tags: [
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居'
      // ]
    },
    {
      id: 5,
      order:5,
      categoryId: 'afa2ba6e254146bd853db8e887797307',
      name: '家电/智能',
      bg_color: '#e55c89',
      color: '#e50089',
      tagList: new Array<string>(),
      hot_list: [
        '广东全屋定制',
        '广西整装',
        '佛山整装',
        '广西整装',
        '佛山整装',
        '西安整装',
        '广东全屋定制',
        '广西整装',
      ],
      icon: require('@/assets/fd/brand/icon5.png'),
      brandBannersList: new Array<any>(),
      refinedDecorationBrandList: new Array<any>(),
      roughcastBrandList: new Array<any>(),
      brandList: new Array<any>(),
      // tags: [
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居'
      // ]
    },
    {
      id: 6,
      order:6,
      categoryId: '0428f31b35394538802f94fcce93a5ab',
      name: '第三方服务',
      bg_color: '#00b7b7',
      color: '#3f95c2',
      tagList: new Array<string>(),
      hot_list: [
        '广东全屋定制',
        '广西整装',
        '佛山整装',
        '广西整装',
        '佛山整装',
        '西安整装',
        '广东全屋定制',
        '广西整装',
      ],
      icon: require('@/assets/fd/brand/icon6.png'),
      brandBannersList: new Array<any>(),
      brandList: new Array<any>(),
      // tags: [
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居',
      //   '顾家家居'
      // ]
    },
  ],
});

const handleTagTabs = (tab: any, event: Event) => {
  load(tab.index);
};

const loadRoot = function () {
  var pageParams = {
    curPage: 1,
    pageSize: 20,
    filtrate: {
      parentId: "ROOT",
      keyword: '',
    },
  };
  store.dispatch('frontBrandModule/listBrandCategory', pageParams).then(
    (data) => {
      console.log(data);
       for (var index = 0; index < bindData.tabData.length; index++) {
        var tabItemData = bindData.tabData[index];
        for (var i = 0; i < data.result.length; i++) {
          const tagObj = data.result[i];
          if(tagObj.id==tabItemData.categoryId) {
              tabItemData.order = tagObj.sort;
          }
        }
       }
       bindData.tabData.sort((a,b)=>{return a.order-b.order}) ;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const loadTags = function (index: number) {
  var tabItemData = bindData.tabData[index];
  var pageParams = {
    curPage: 1,
    pageSize: 20,
    filtrate: {
      parentId: tabItemData.categoryId,
      keyword: '',
    },
  };
  store.dispatch('frontBrandModule/listBrandCategory', pageParams).then(
    (data) => {
      console.log(data);
      //成功
      var tagList: string[] = new Array(data.result.length);
      for (var i = 0; i < data.result.length; i++) {
        const tagObj = data.result[i];
        tagList[i] = tagObj.name;
      }
      tabItemData.tagList = tagList;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const loadBrands = function (
  index: number,
  decorateTypeId: string,
  brandCategory: string,
  hasBrandBigLogo: string,
  pageSize: number,
  callbackfn: (index: number, value: any) => void
) {
  var tabItemData = bindData.tabData[index];
  var pageParams = {
    curPage: 1,
    pageSize: pageSize,
    filtrate: {
      industry: tabItemData.name,
      decorateTypeId: decorateTypeId,
      businessCategory: brandCategory,
      hasBrandBigLogo: hasBrandBigLogo,
      keyword: '',
    },
  };
  store.dispatch('frontBrandModule/listCompanyBrand', pageParams).then(
    (data) => {
      console.log(data);
      //成功
      //不足15个时补上Example
      bindData.brandExampleList.sort(function () { return 0.5 - Math.random(); });
      bindData.brandExampleBigList.sort(function () { return 0.5 - Math.random(); });
      if (hasBrandBigLogo == 'Y') {
        if (data.result.length < pageSize) {
          for (var i = data.result.length; i < pageSize; i++) {
            data.result.push({
              projectCount: 0,
              brandBigLogoFullPath: bindData.brandExampleBigList[i]
            });
          }
        }
      }
      else {
        if (data.result.length < pageSize) {
          for (var i = data.result.length; i < pageSize; i++) {
            data.result.push({
              projectCount: 0,
              brandLogoFullPath: bindData.brandExampleList[i],
            });
          }
        }
      }

      callbackfn(index, data.result);
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const load = function (tabIndex: number) {
  loadTags(tabIndex);
  //精装修排行
  loadBrands(
    tabIndex,
    '022581579baf45609b327c9bff7f3ad2',
    '',
    '',
    5,
    function (index: number, value: any) {
      var tabItemData = bindData.tabData[index];
      tabItemData.refinedDecorationBrandList = value;
    }
  );
  //毛坯排行
  loadBrands(
    tabIndex,
    '0e725100e487424ca2b96085d57ad74d',
    '',
    '',
    5,
    function (index: number, value: any) {
      var tabItemData = bindData.tabData[index];
      tabItemData.roughcastBrandList = value;
    }
  );
  //品牌
  loadBrands(tabIndex, '', '', '', 15, function (index: number, value: any) {
    var tabItemData = bindData.tabData[index];
    tabItemData.brandList = value;
  });
  //品牌形象大图
  loadBrands(tabIndex, '', '', 'Y', 2, function (index: number, value: any) {
    var tabItemData = bindData.tabData[index];
    tabItemData.brandBannersList = value;
  });
};

loadRoot();
load(0);

const handlTagClick = (tabIndex: number, tagName: string) => {
  loadBrands(
    tabIndex,
    '',
    tagName,
    '',
    15,
    function (index: number, value: any) {
      var tabItemData = bindData.tabData[index];
      tabItemData.brandList = value;
    }
  );
};

const handleToPage = () => {
  router.push('/frontDesk/brandList');
};


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_arrow_right_bold = _resolveComponent("arrow-right-bold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
        class: "demo-tabs",
        onTabClick: handleTagTabs
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tabData, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.id,
              label: item.name,
              name: item.name
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_container, { class: "brand-index-rank" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_el_image, {
                            class: "brand-index-rank-lt-icon1",
                            src: require('@/assets/fd/brand/u4321.png')
                          }, null, 8, ["src"]),
                          _hoisted_5
                        ]),
                        _createVNode(_component_el_image, {
                          class: "brand-index-rank-lt-icon2",
                          src: require('@/assets/fd/brand/u4284.png')
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.refinedDecorationBrandList, (obj, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "brand-index-rank-rt-imgs-item",
                              key: obj.id
                            }, [
                              _createVNode(_component_el_image, {
                                src: obj.brandLogoFullPath,
                                style: {"border":"1px solid #cccccc"}
                              }, null, 8, ["src"]),
                              _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, _toDisplayString("" + (index+1)), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_container, { class: "brand-index-rank" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_el_image, {
                            class: "brand-index-rank-lt-icon1",
                            src: require('@/assets/fd/brand/u4321.png')
                          }, null, 8, ["src"]),
                          _hoisted_13
                        ]),
                        _createVNode(_component_el_image, {
                          class: "brand-index-rank-lt-icon2",
                          src: require('@/assets/fd/brand/u4284.png')
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.roughcastBrandList, (obj, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "brand-index-rank-rt-imgs-item",
                              key: obj.id
                            }, [
                              _createVNode(_component_el_image, {
                                src: obj.brandLogoFullPath,
                                style: {"border":"1px solid #cccccc"}
                              }, null, 8, ["src"]),
                              _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, _toDisplayString("" + (index+1)), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createVNode(_component_el_container, { class: "brand-index-box" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: "brand-index-aside-tp",
                        style: _normalizeStyle(`background:${item.bg_color}`)
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: "brand-index-aside-tp-hd-rt",
                            onClick: handleToPage
                          }, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(item.name), 1),
                            _hoisted_22,
                            _createVNode(_component_el_icon, {
                              class: "el-icon--right",
                              size: "20",
                              style: {"color":"#ffffff"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_arrow_right_bold)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tagList, (obj) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "brand-index-aside-tp-box",
                            key: obj,
                            onClick: ($event: any) => (handlTagClick(index, obj))
                          }, [
                            _createElementVNode("div", {
                              class: "brand-index-aside-tp-item",
                              style: _normalizeStyle(`background:${item.color}`)
                            }, _toDisplayString(obj), 5)
                          ], 8, _hoisted_23))
                        }), 128))
                      ], 4)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.brandBannersList, (obj) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "brand-index-main-banners-item",
                            key: obj.id
                          }, [
                            _createVNode(_component_el_image, {
                              src: obj.brandBigLogoFullPath
                            }, null, 8, ["src"])
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.brandList, (obj) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "brand-index-main-imgs-item",
                            key: obj.id
                          }, [
                            _createVNode(_component_el_image, {
                              src: obj.brandLogoFullPath
                            }, null, 8, ["src"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_el_image, {
                src: require('@/assets/fd/brand/library1.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_el_image, {
                src: require('@/assets/fd/brand/library2.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_36
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_el_image, {
                src: require('@/assets/fd/brand/library3.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_39
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_el_image, {
                src: require('@/assets/fd/brand/library4.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_42
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_el_image, {
                src: require('@/assets/fd/brand/library5.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_45
          ])
        ])
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})